import React from 'react';

import Modal from '../Modal';

import TableLoader from '../TableLoader';
import { Container } from './styles';

interface LoaderModalProps {
  show: boolean;
  title: string;
  handleClose(): void;
}

const LoaderModal: React.FC<LoaderModalProps> = ({
  handleClose,
  show,
  title,
}) => {
  return (
    <Container>
      <Modal show={show} title={title} handleClose={handleClose}>
        <TableLoader />
      </Modal>
    </Container>
  );
};

export default LoaderModal;
